/** Default thresholds for customer COD risk scoring (Phase 17.A). */

export const SHIPPED_LIKE_STATUSES = [
  "shipped",
  "delivered",
  "picked_up",
  "returned",
] as const;

/** Score deltas — higher = riskier */
export const RISK_SCORE = {
  newCustomer: 25,
  highReturnRate: 30,
  mildReturnRate: 15,
  staleCod: 20,
  lowCodSuccess: 25,
  returningNoReturn: -20,
  strongCodSuccess: -15,
  proposedAbove2xAvg: 15,
  newCustomerHighTotal: 15,
  /** Shop-wide return rate of customer's last carrier/branch */
  highBranchReturnRate: 15,
  mildBranchReturnRate: 8,
} as const;

export const RISK_THRESHOLDS = {
  /** returnRate >= this → high return penalty */
  highReturnRate: 0.2,
  /** codSuccessRate below this (with ≥1 COD) → penalty */
  lowCodSuccessRate: 0.5,
  /** codSuccessRate at/above this with ≥3 COD → bonus */
  strongCodSuccessRate: 0.9,
  minCodOrdersForStrongBonus: 3,
  /** proposedTotal >= this for new customers → penalty (LAK) */
  newCustomerTotalLak: 500_000,
  /** Score → tier */
  depositScoreMin: 30,
  prepaidScoreMin: 60,
  /** Default deposit suggestion when tier = require_deposit */
  defaultDepositPct: 30,
  /** Align with alert_stale_shipped_cod_days default */
  staleShippedCodDays: 7,
  /**
   * Branch return rate (align with shipping-performance insight bands).
   * Only applied when branchShippedCount >= minBranchSample.
   */
  highBranchReturnRate: 0.15,
  mildBranchReturnRate: 0.08,
  minBranchSample: 5,
} as const;

export type CustomerRiskTier =
  | "allow_cod"
  | "require_deposit"
  | "prepaid_only";
